import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

/** @jsx jsx */
import { Component } from 'react';
import { jsx } from '@emotion/core';
import Button, { Theme as ButtonTheme } from '@atlaskit/button/custom-theme-button';
import Modal, { ModalBody } from '@atlaskit/modal-dialog';
import { ModalBody as Body, ModalHeading as Heading, ModalActionContainer, ModalActionItem, ModalImage } from '../styled/modal';
import { modalButtonTheme } from './theme'; // TODO: DSP-1250 - use a composable API consistent with normal modal dialog

function noop() {}
/**
 * __Onboarding modal__
 *
 * If the product change is large enough,
 * this component can be used to outline the benefits of the change to the user.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/onboarding)
 */


export default class OnboardingModal extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "headerComponent", props => {
      const {
        header: HeaderElement,
        image: src
      } = props;

      const ImageElement = () => jsx(ModalImage, {
        src: src,
        alt: ""
      });

      return HeaderElement || ImageElement;
    });

    _defineProperty(this, "footerComponent", props => {
      const {
        footer: FooterElement,
        actions: actionList,
        experimental_shouldShowPrimaryButtonOnRight = false
      } = props;

      const ActionsElement = () => actionList ? jsx(ButtonTheme.Provider, {
        value: modalButtonTheme
      }, jsx(ModalActionContainer, {
        shouldReverseButtonOrder: experimental_shouldShowPrimaryButtonOnRight
      }, actionList.map(({
        text,
        key,
        ...rest
      }, idx) => {
        const variant = idx ? 'subtle-link' : 'primary';
        return jsx(ModalActionItem, {
          key: key || (typeof text === 'string' ? text : `${idx}`)
        }, jsx(Button, _extends({
          appearance: variant,
          autoFocus: !idx
        }, rest), text));
      }))) : null;

      return FooterElement || ActionsElement;
    });
  }

  render() {
    const {
      actions,
      children,
      heading,
      ...props
    } = this.props;
    const Header = this.headerComponent(this.props);
    const Footer = this.footerComponent(this.props);
    return jsx(Modal, _extends({
      autoFocus: true,
      onClose: noop,
      shouldScrollInViewport: true,
      shouldCloseOnOverlayClick: false,
      shouldCloseOnEscapePress: false
    }, props), jsx(Header, null), jsx(ModalBody, null, jsx(Body, null, heading && jsx(Heading, null, heading), children)), jsx(Footer, null));
  }

}